// React Basic and Bootstrap
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

import workflow from '../../assets/images/itoagent/workflow.png';

const Workflow = () => {
  return (
    <React.Fragment>
      <Container className="mt-100 mt-60">
        <Row className="align-items-center">
          <Col xs="12" className="text-center">
            {/* <Col lg={12} md={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0"> */}
            <div className="section-title me-lg-5">
              <h4 className="title mb-4">
                Respond to customer inquiries anytime, anywhere.
              </h4>
              <p className="text-muted">
                Receive alerts even when your team is offline, then let
                available agents accept customer requests in real time.
              </p>

              <Row className="justify-content-center">
                <Col xs="6" className="text-end">
                  <h5>
                    <span className="text-primary h5 me-2">
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Capture Every Lead
                  </h5>
                </Col>
                <Col xs="6" className="text-start">
                  <h5>
                    <span className="text-primary h5 me-2">
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Align with your customers' demand
                  </h5>
                </Col>
              </Row>

              {/**
              <ul className="list-unstyled text-muted">
                <li className="mb-1">
                  <span className="text-primary h5 me-2">
                    <i className="uil uil-check-circle align-middle"></i>
                  </span>
                  Capture Every Lead
                </li>
                <li className="mb-1">
                  <span className="text-primary h5 me-2">
                    <i className="uil uil-check-circle align-middle"></i>
                  </span>
                  Align with your customers' demand
                </li>
              </ul>

               **/}
              {/**
              <Link to="#" className="mt-3 h6 text-primary">Find Out More <i className="uil uil-angle-right-b"></i></Link>
              **/}
            </div>
          </Col>
          {/**
          <Col lg={5} md={6} className="">
             <img src={workflow} alt="" /> 
          </Col>
        **/}
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Workflow;
